import React from "react";

const Experience: React.FC = () => {
  return (
    <section className="section active">
      {/* Hero section with image */}
      <div className="hero">
        <h1>Experience</h1>
        <img
          src="/images/Professor-Alex-Mari-Bahrain-University-Middle-East.jpg"
          alt="Dr. Alex Mari - Experience"
          className="hero-image"
        />
      </div>

      {/* Main content with consistent spacing */}
      <div className="bio">
        <h2>Work Experience</h2>

        <h3>Teaching Experience</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>07/25 -</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  AMERICAN UNIVERSITY OF BAHRAIN
                </strong>
                , <em>BAHRAIN</em>
              </div>
              <div>
                Assistant Professor of Marketing and Management, College of
                Business and Management
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>09/24 -</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>CATHOLIC UNIVERSITY OF SACRED HEART</strong>,{" "}
                <em>ITALY</em>
              </div>
              <div>Visiting Professor of Marketing Analytics</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>01/23 -</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  SBS SWISS BUSINESS SCHOOL
                </strong>
                , <em>SWITZERLAND</em>
              </div>
              <div>Adjunct Professor of Marketing Strategy</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2022 - 2025
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>UNIVERSITY OF ZURICH</strong>, <em>SWITZERLAND</em>
              </div>
              <div>Lecturer of Digital Marketing and Branding</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2012 - 2023
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  SDA BOCCONI, SCHOOL OF MANAGEMENT and BOCCONI ASIA CENTER
                </strong>
                , <em>ITALY</em>
              </div>
              <div>
                Invited Module Lecturer in Digital and AI for Marketing –
                Executive
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2014 / 2019
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>BOCCONI UNIVERSITY</strong>, <em>ITALY</em>
              </div>
              <div>
                Co-Lecturer in Social Media Marketing Laboratory – Master
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2014 - 2018
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  INTERNATIONAL INSTITUTE IN GENEVA
                </strong>
                , <em>SWITZERLAND</em>
              </div>
              <div>Adjunct Faculty in Digital Marketing – MBA</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2010 - 2013
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>MASTER PUBLITALIA MEDIASET</strong>, <em>ITALY</em>
              </div>
              <div>
                Adjunct Faculty in Digital Marketing – Professional Master
              </div>
            </div>
          </div>
        </div>

        <h3>Research Experience</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>07/24 -</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  AI EMPATHY RESEARCH INITIATIVE
                </strong>
                , <em>SWITZERLAND</em>
              </div>
              <div>Co-founder and Research Scientist</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              09/18 - 09/24
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>UNIVERSITY OF ZURICH</strong>, <em>SWITZERLAND</em>
              </div>
              <div>Senior Research Associate</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2008 - 2010
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  UNIVERSITY OF LUGANO (USI) / SDA BOCCONI
                </strong>
                , <em>SWITZERLAND AND ITALY</em>
              </div>
              <div>
                Research Assistant Digital Marketing and Communication{" "}
                <em>(50%)</em>
              </div>
            </div>
          </div>
        </div>

        <h3>Managerial Experience</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              08/15 - 12/16
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>SONOVA GROUP</strong>,{" "}
                <em>SWITZERLAND</em>
              </div>
              <div>Global Director of Digital Marketing & E-Commerce</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              10/11 - 10/13
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>PROCTER & GAMBLE</strong>, <em>SWITZERLAND</em>
              </div>
              <div>Brand Manager</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              12/10 - 09/11
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>TIM MUSIC</strong>,{" "}
                <em>SWITZERLAND</em>
              </div>
              <div>Head of Digital Marketing</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              02/09 - 07/09
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>AKQA</strong>, <em>ITALY</em>
              </div>
              <div>Digital Marketing Trainee</div>
            </div>
          </div>
        </div>

        <h3>Entrepreneurial Experience</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>01/25 -</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>CARY ALLY</strong>,{" "}
                <em>SWITZERLAND</em>
              </div>
              <div>Founder</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              01/17 - 06/18
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>FENNEX AG</strong> (Joint Venture), <em>SWITZERLAND</em>
              </div>
              <div>CEO and Co-Founder</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              11/13 - 07/15
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>BRANDMATE Ltd.</strong>,{" "}
                <em>VIETNAM</em>
              </div>
              <div>CEO and Founder</div>
            </div>
          </div>
        </div>

        <h2>Education</h2>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2018 - 2024
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  UNIVERSITY OF ZURICH
                </strong>
                , <em>SWITZERLAND</em>
              </div>
              <div>Doctorate in Business Administration, Marketing</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2020 - 2021
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>SAID BUSINESS SCHOOL, UNIVERSITY OF OXFORD</strong>,{" "}
                <em>UK</em>
              </div>
              <div>Visiting PhD Program, Strategic Management</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2007 - 2010
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  UNIVERSITY OF LUGANO
                </strong>
                , <em>SWITZERLAND</em>
              </div>
              <div>
                Master of Science in Communication and Economics, Marketing
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2008</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>CENTRAL UNIVERSITY OF FINANCE & ECONOMICS</strong>,{" "}
                <em>CHINA</em>
              </div>
              <div>Exchange Master Student in International Business *</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>
              2004 - 2007
            </span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  LIBERA UNIVERSITA' MARIA SS. ASSUNTA (LUMSA)
                </strong>
                , <em>ITALY</em>
              </div>
              <div>
                Bachelor of Arts in Corporate Communication, Marketing and
                Advertising
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2006</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>ABO AKADEMI UNIVERSITY</strong>, <em>FINLAND</em>
              </div>
              <div>
                Erasmus Bachelor Student in Intercultural Communication *
              </div>
            </div>
          </div>
        </div>

        <h3>PhD Summer School</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2023</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  MIT SLOAN SCHOOL OF MANAGEMENT
                </strong>
                , <em>USA</em>
              </div>
              <div>
                Summer School Medici in Management Studies - Platform Economy
                (invitation only)
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2020</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>UNIVERSITY OF ST. GALLEN</strong>, <em>SWITZERLAND</em>
              </div>
              <div>
                Summer School in Mediation, Moderation, and Conditional Analysis
                (I & II)
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2019</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  UNIVERSITY OF CALABRIA
                </strong>
                , <em>ITALY</em>
              </div>
              <div>Summer School in Experimental Design and Analysis</div>
            </div>
          </div>
        </div>

        <h3>Executive Programs</h3>
        <div className="publication-list">
          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2018</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>SDA BOCCONI SCHOOL OF MANAGEMENT</strong>,{" "}
                <em>ITALY</em>
              </div>
              <div>
                Big Data and Artificial Intelligence Marketing for executives
                (auditor)
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2017</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  CANNES LIONS SCHOOL
                </strong>
                , <em>FRANCE</em>
              </div>
              <div>CMO Accelerator Program for executives</div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2014</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong>CEU BUSINESS SCHOOL</strong>, <em>HUNGARY</em>
              </div>
              <div>
                Global Entrepreneurship Fellows Program for executives *
              </div>
            </div>
          </div>

          <div
            className="publication-item"
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "1rem" }}
          >
            <span style={{ minWidth: "100px", flexShrink: 0 }}>2011</span>
            <div style={{ flex: 1, paddingLeft: "20px" }}>
              <div style={{ marginBottom: "0.25rem" }}>
                <strong style={{ color: "#0D47A1" }}>
                  SDA BOCCONI SCHOOL OF MANAGEMENT
                </strong>
                , <em>ITALY</em>
              </div>
              <div>Diploma Digital Marketing for executives *</div>
            </div>
          </div>
        </div>

        <div
          style={{ marginTop: "2rem", fontStyle: "italic", textAlign: "right" }}
        >
          * ~one semester
        </div>
      </div>
    </section>
  );
};

export default Experience;
